module.exports = __webpack_public_path__ + "static/media/analysis-macrovector-02-b 4.44964375.png";